import { NineButton, NineHeading } from "@9amhealth/wcl/generated/react";
import { useBlocNext } from "@blac/react";
import { FC } from "react";
import Translate from "src/ui/components/Translate/Translate";
import { ChatUploadLabResultsCubit } from "../ChatUploadLabResultsCubit";
import { InfoText, StepContent, SupportActions } from "../components";

interface PdfInfoScreenProps {
  isUploading: boolean;
}

export const PdfInfoScreen: FC<PdfInfoScreenProps> = ({ isUploading }) => {
  const [, { setCurrentStep }] = useBlocNext(ChatUploadLabResultsCubit);

  const handleBackToUpload = () => {
    setCurrentStep("upload");
  };

  return (
    <StepContent>
      <NineHeading>
        <h3 className="as-h4-large">
          <Translate msg="chat.labUpload.pdfInfo.title" />
        </h3>
      </NineHeading>
      <InfoText>
        <Translate msg="chat.labUpload.pdfInfo.description" />
      </InfoText>
      <SupportActions>
        <NineButton
          onClick={handleBackToUpload}
          disabled={isUploading ? "true" : "false"}
        >
          <Translate msg="chat.labUpload.howToGetReport.back" />
        </NineButton>
      </SupportActions>
    </StepContent>
  );
};
